import React from 'react'
const PlayIcon = ({
  width = 108,
  height = 108,
  color = '#299D6B',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 108 108"
    fill="none"
    {...props}
  >
    <rect width={108} height={108} rx={54} fill="white" />
    <path
      d="M9 54C9 29.1472 29.1472 9 54 9C78.8528 9 99 29.1472 99 54C99 78.8528 78.8528 99 54 99C29.1472 99 9 78.8528 9 54ZM48.8503 36.6974C45.1012 34.6209 40.5 37.3324 40.5 41.6181V66.3821C40.5 70.6678 45.1012 73.3792 48.8503 71.3028L74.7602 56.9525C75.8338 56.3579 76.5 55.2274 76.5 54.0001C76.5 52.7728 75.8338 51.6423 74.7602 51.0477L48.8503 36.6974Z"
      fill={color}
    />
  </svg>
)
export default PlayIcon
